import React, { useEffect, useState } from 'react';
import StatusLevel from 'components/StatusLevel';
import FavouriteStats from 'components/FavouriteStats';
import LoyaltyTotals from 'components/LoyaltyTotals';
import LevelProgress from 'components/LevelProgress';
import Benefits from 'components/Benefits';
import AchievementsWaiting from './AchievementsWaiting';
import AchievementsPageReady from './AchievementsPageReady';
import { getLoyaltyAchievementsQuery } from './query';

const LoyaltyAchievements = ({ isUnlocking, onLocked, loyaltyProgram }) => {
  const [achievements, setAchievements] = useState(null);

  const onData = (response) => {
    setAchievements(response.data.data.achievements);
  };

  const stats = achievements?.stats;
  const isLocked = achievements !== null && !achievements.unlocked;

  // The evaluation is queued, so a customer who has just scanned is enrolled
  // before anything has been counted. Stats stay null until that job runs.
  const isCounting = achievements?.unlocked === true && !stats;

  useEffect(() => {
    if (isLocked && !isUnlocking) {
      onLocked();
    }
  }, [isLocked, isUnlocking, onLocked]);

  if (isUnlocking) {
    return <AchievementsWaiting />;
  }

  return (
    <AchievementsPageReady
      query={getLoyaltyAchievementsQuery()}
      isCounting={isCounting}
      onData={onData}>
      {achievements?.unlocked && stats ? (
        <div className="loyalty-page__cards">
          <StatusLevel name={achievements.current_level.name} />
          <FavouriteStats
            category={stats.favourite_category}
            brand={stats.favourite_brand}
          />
          <LoyaltyTotals stats={stats} />
          <LevelProgress
            levels={achievements.levels}
            currentLevel={achievements.current_level}
            nextLevel={achievements.next_level}
            seals={achievements.seals}
          />
          {loyaltyProgram ? <Benefits loyaltyProgram={loyaltyProgram} /> : null}
        </div>
      ) : null}
    </AchievementsPageReady>
  );
};

export default LoyaltyAchievements;
